import angular from 'angular';
import '../core.module';

class MenuService {
  constructor(MENU_ITEMS, SessionService) {
    this.MENU_ITEMS = MENU_ITEMS;
    this.SessionService = SessionService;
  }

  getMenu() {
    return this.MENU_ITEMS.map((section) => ({
      ...section,
      items: section.items.filter((item) => this.SessionService.hasPermission(item.permission))
    })).filter((section) => section.items.length > 0);
  }
}

MenuService.$inject = ['MENU_ITEMS', 'SessionService'];

angular.module('app.core').service('MenuService', MenuService);

export default MenuService;
